import {
    GET_CUSTOMER_PAYMENT_DATE_WISE_REQUEST,
    GET_CUSTOMER_PAYMENT_DATE_WISE_SUCCESS,
    GET_CUSTOMER_PAYMENT_DATE_WISE_ERROR, 
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_CUSTOMER_PAYMENT_DATE_WISE_REQUEST:
            return {
                loading: true,
            };
        case GET_CUSTOMER_PAYMENT_DATE_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_CUSTOMER_PAYMENT_DATE_WISE_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}